import Tippy from '@tippyjs/react';
import { useTranslation } from 'next-i18next';
import { VFC } from 'react';

import IconActive from '@/icons/bookmark-star-fill.svg';
import IconInactive from '@/icons/bookmark-star.svg';

import styles from './UserFavoriteButton.module.scss';

type UserFavoriteButtonProps = {
  isFavorited: boolean;
  onClick: () => void;
};

export const UserFavoriteButton: VFC<UserFavoriteButtonProps> = ({
  isFavorited,
  onClick,
}: UserFavoriteButtonProps) => {
  const { t } = useTranslation();

  if (isFavorited) {
    return (
      <Tippy
        content={t('userFavorite.deleteButtonDescription')}
        hideOnClick={false}
      >
        <button onClick={() => onClick()} className={styles.userFavoriteButton}>
          <IconActive />
        </button>
      </Tippy>
    );
  }

  return (
    <Tippy content={t('userFavorite.addButtonDescription')} hideOnClick={false}>
      <button onClick={() => onClick()} className={styles.userFavoriteButton}>
        <IconInactive />
      </button>
    </Tippy>
  );
};
